import { Icon } from '@innovationnorway/cl-react';
import classNames from 'classnames';
import React from 'react';
type Props = {
  isSubmitted: boolean;
};
const SivaDeliveredIcon: React.FC<Props> = ({ isSubmitted }) => {
  const label = isSubmitted ? 'Levert' : 'Ikke levert';
  return (
    <Icon
      prefix="fasr"
      iconName={isSubmitted ? 'check-circle' : 'times'}
      title={label}
      aria-label={label}
      className={classNames({
        'color--in-green-200': isSubmitted,
        'color--red': !isSubmitted,
      })}
    />
  );
};
export default SivaDeliveredIcon;
